import React, { Fragment, useContext } from "react";
import { H4, LI, UL, Image } from "../../../../AbstractElements";
import { getCartTotal } from "../../../../Services/Ecommerce.service";
import CartContext from "../../../../_helper/Ecommerce/Cart";
import paypal from "../../../../assets/images/checkout/paypal.png";
import upi from "../../../../assets/images/checkout/Group 34387.png";
import { Col, Input, Label, Row } from "reactstrap";

const ProductPlaceOrder = ({ rowData, data }) => {
  const { cart } = useContext(CartContext);
  console.log(rowData)
  const payment = rowData.payment && rowData.payment.length > 0 ? rowData.payment[0] : null;

    const dueAmount = payment ? (payment.balance_amount !== null ? (payment.discount_amt - payment.already_paid_amount) : payment.total) : '-';
    const discount = payment ? (payment.discount !== null ? payment.discount : "Nill") : '-';
    const discountedAmount = payment ? (payment.discount_amt !== null ? payment.discount_amt : 'Nill') : '-';
    const alreadyPaidAmount = payment ? (payment.already_paid_amount !== null ? payment.already_paid_amount : '-') : '-';
  return (
    <Fragment>
      <Col xl="6" sm="12">
        <div className="checkout-details">
          <div className="order-box">
            <div className="title-box">
              <div className="checkbox-title">
                <H4>Treatment </H4>
                <span>Total</span>
              </div>
            </div>

           
            {/* <UL attrUL={{ className: "simple-list sub-total total" }}>
              <LI attrLI={{ className: "border-0 bg-transparent " }}>
                <b> Discounted Amount </b>
                <span className="count">
                  &#x20B9;<b> {rowData.payment.map((d) => d.total)} </b>
                  <br />
                </span>
              </LI>
            </UL> */}
            <UL attrUL={{ className: "simple-list sub-total total" }}>
              <LI attrLI={{ className: "border-0 bg-transparent " }}>
                <b> Total </b>
                <span className="count">
                  &#x20B9;<b> {rowData.payment.map((d) => d.total)} </b>
                  <br />
                </span>
              </LI>
            </UL>
            <UL attrUL={{ className: "simple-list sub-total total" }}>
              <LI attrLI={{ className: "border-0 bg-transparent " }}>
                <b> Discounted Amount </b>
                <span className="count">
                  &#x20B9;<b> {payment.discount_amt} </b>
                  <br />
                </span>
              </LI>
            </UL>
            <UL attrUL={{ className: "simple-list sub-total total" }}>
              <LI attrLI={{ className: "border-0 bg-transparent " }}>
                Due Amount{" "}
                <span className="count">
                  &#x20B9;{" "}
                  {dueAmount}
                </span>
              </LI>
            </UL>
            <UL attrUL={{ className: "simple-list sub-total total" }}>
              <LI attrLI={{ className: "border-0 bg-transparent " }}>
                Already Paid Amount{" "}
                <span className="count">
                  &#x20B9;{" "}
                  {alreadyPaidAmount}
                </span>
              </LI>
            </UL>

            {/* <div className='animate-chk'>
              <Row>
                <Col>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani'>
                    <Input className='radio_animated' id='edo-ani' type='radio' name='rdo-ani' data-original-title='' title='' />
                    Check Payments
                  </Label>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani1'>
                    <Input className='radio_animated' id='edo-ani1' type='radio' name='rdo-ani' data-original-title='' title='' />
                    Cash
                  </Label>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani2'>
                    <Input className='radio_animated' id='edo-ani2' type='radio' name='rdo-ani' data-original-title='' title='' />
                    UPI ID
                    <Image attrImage={{ className: 'img-upi', src: `${upi}`, alt: 'UPI Payment' }} />
                  </Label>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani3'>
                    <Input className='radio_animated' id='edo-ani3' type='radio' name='rdo-ani' data-original-title='' title='' />
                    PayPal
                    <Image attrImage={{ className: 'img-paypal', src: `${paypal}`, alt: 'Paypal' }} />
                  </Label>
                </Col>
              </Row>
            </div> */}
          </div>
        </div>
      </Col>
    </Fragment>
  );
};
export default ProductPlaceOrder;
